import React from "react"

import ContinuousMetricBox from "./ContinuousMetricBox"

export default ({ topics, sources, classified, approved, stakeholders }) => (
    <div className="metric-box-container col col-xs-12 col-xl-8 parent widget-bottom-margin">
        <ContinuousMetricBox title="Topics online" metric={topics} />
        <ContinuousMetricBox title="Source areas online" metric={sources} />
        <ContinuousMetricBox title="Stakeholders online" metric={stakeholders} />
        <ContinuousMetricBox title="Articles classified today" metric={classified} />
        <ContinuousMetricBox title="Articles approved today" metric={approved} />
    </div>
)
